import { Box, Container, CssBaseline, Typography, useMediaQuery } from "@mui/material";
import { FC, ReactElement, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router";
import Header from '../../components/AppBar/Header';

const LandingPage: FC = (): ReactElement => {
  const location = useLocation();
  const { t } = useTranslation();
  const isDark = useMediaQuery('(prefers-color-scheme: dark)');

  useEffect(() => {
    const hash = location.hash.replace('#', '');
    if (hash) {
      const element = document.getElementById(hash);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [location]);

  return (
  <>
    <CssBaseline />
    <Header />
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        backgroundColor: "background.default",
        padding: 4,
        gap: 6,
      }}
    >
      {/* Logos */}
      <Box sx={{ display: "flex", alignItems: "center", gap: 8 }}>
        <Box
          component="img"
          src={isDark ? '/logos/ReA_Logotipo_comAssinatura_Negativo.png' : '/logos/ReA_Logotipo_comAssinatura_Positivo.png'}
          alt="RioseAquíferos"
          sx={{ height: 250, objectFit: "contain" }}
        />

        {/* Separador */}
        <Box sx={{ width: "1px", height: 120, borderLeft: "1px solid", borderColor: "divider" }} />

        <Box
          component="img"
          src={isDark ? '/logos/W2Y_Logotipo_Negativo.png' : '/logos/W2Y_Logotipo_Positivo.png'}
          alt="Water2You"
          sx={{ height: 250, objectFit: "contain" }}
        />
      </Box>

      {/* Texto */}
      <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 2 }}>
        <Typography variant="h2" component="h1" fontWeight="bold" color="primary">
          BDSUB
        </Typography>
        <Typography variant="h5" component="p" color="text.secondary">
          {t("generic.landing.title")}
        </Typography>
        <Container maxWidth="sm" sx={{ mt: 1 }}>
          <Typography variant="body1" color="text.secondary">
            {t("generic.landing.description")}
          </Typography>
        </Container>
      </Box>

    </Box>
  </>
);
};

export default LandingPage;